<template>
  <div style="width: 100%">
    <h3 class="sectionTitle title" data-aos="fade-up">Пропозицiя</h3>
    <div class="contentWrapperPadding">
      <div class="mainOfferWrapper" data-aos="fade-up">
        <div class="offerContainer">
          <OfferCard />
        </div>
        <div class="formWrapper">
          <OfferForm />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OfferCard from './components/OfferCard.vue';
import OfferForm from './components/OfferForm.vue';

export default {
  name: 'Offers',
  components: {
    OfferCard,
    OfferForm
  }
};
</script>

<style lang="scss" scoped>
.mainOfferWrapper {
  margin-top: 4.792rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media screen and (max-width: 768px) {
  .mainOfferWrapper {
    display: flex;
    flex-direction: column;
  }

  .formWrapper {
    margin-top: 15.625rem;
  }

  .title {
    margin-bottom: 10rem;
  }
}
</style>
